export function combineBookingQuote(services:ReadonlyArray<{price:number;price_max?:number|null;duration_minutes:number}>){
 if(!services.length)return null;
 return services.reduce((sum,service)=>({durationMinutes:sum.durationMinutes+service.duration_minutes,priceMin:sum.priceMin+service.price,priceMax:sum.priceMax+(service.price_max===null||service.price_max===undefined?service.price:service.price_max)}),{durationMinutes:0,priceMin:0,priceMax:0});
}
